// extracted by mini-css-extract-plugin
module.exports = {"Indicators":"Indicators_Indicators__5gitn","Indicators__title":"Indicators_Indicators__title__27kRf","Indicators__select":"Indicators_Indicators__select__2JHxy"};